import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import {progressMiddleware, sfcApi} from './api';
import jokeReducer from './slicers/jokeSlice';
import modalReducer from './slicers/modalSlice';

export const store = configureStore({
  reducer: {
    [sfcApi.reducerPath]: sfcApi.reducer,
    jokes: jokeReducer,
    modal: modalReducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(sfcApi.middleware, progressMiddleware)
});

setupListeners(store.dispatch);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
